<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi" id="ch00_fm05_dedi"><a id="page_v"></a>Dedicated to the ones</p>
<p class="dedi1">Who in the struggle for a more equal and just world</p>
<p class="dedi1">Face the unmitigated mutations of colonial and neoliberal discourses</p>
<p class="dedi1">Like infections that wear you out</p>
<p class="dedi1">The best among us</p>
<p class="dedi1">With the guise of care that protects the Self-same.</p>
<p class="dedi1">You watch in disgust, sickened</p>
<p class="dedi1">But know better</p>
<p class="dedi1">That nothing could wipe out your queer spirit</p>
<p class="dedi1">Or the labor of your kind</p>
<p class="dedi1">In the solidarity of our minds.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedi.vue?1296e6c2